// Sanitize author-supplied CSS before injecting into a <style> tag.
//
// Pure JS (no DOM), so it runs identically on the server and the client — unlike the old
// `dompurify` CSS sanitizer whose `sanitize` is not a function on the server (it threw during SSR
// and de-opted the whole page to client rendering). `sanitize-html` can't be used for CSS (it drops
// the contents of <style> as a nonTextTag), so we strip the same dangerous constructs DOMPurify's
// CSS sanitizer removed (expression(), @import, javascript:, behavior/-moz-binding) and neutralise
// any </style> tag-breakout attempt, keeping the rest of the (CMS-authored) CSS intact.
export function sanitizeCss(css: string): string {
  if (typeof css !== 'string') return '';
  return css
    // Neutralise <style>/</style> breakout attempts and drop any stray HTML tags (CSS has none).
    .replace(/<\/?\s*style[^>]*>/gi, '')
    .replace(/<[^>]*>/g, '')
    // IE expression() + vendor binding vectors.
    .replace(/expression\s*\(/gi, '/*blocked*/(')
    .replace(/-moz-binding\s*:/gi, '/*blocked*/:')
    .replace(/behavior\s*:/gi, '/*blocked*/:')
    // External resource loading.
    .replace(/@import[^;]*;?/gi, '')
    // javascript: URLs (inside url(...) or anywhere).
    .replace(/url\(\s*(['"]?)\s*javascript:[^)]*\1\s*\)/gi, 'url()')
    .replace(/javascript\s*:/gi, '');
}
